import Cookies from "universal-cookie";
import {
  useDashboardUIActions,
} from "@contexts/dashboardUI";
import { createAuthenticatedFetch } from "@utils/authenticatedFetch";

const cookies = new Cookies();
const costsFetch = createAuthenticatedFetch({
  serverUrl: process.env.COSTS_SERVER_URL,
  getToken: () => cookies.get("userId")?.token,
});


export default (state, dispatch) => {
  const fetch = costsFetch;
  const getBuildings = async (costsIds) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    let costsIdsString = costsIds
    if (Array.isArray(costsIds)) costsIdsString = costsIds.join(',');
    let response
    try {
      response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getBuildings?costsIds=${costsIdsString}`, {
        method: "GET"
      }).then(res => res.json())
    } catch {
      // Módulo Costs pode estar indisponível/não configurado (ex.: dev sem COSTS_SERVER_URL
      // real) — não pode derrubar a tela inteira com um erro de fetch não tratado.
      response = { res: [] }
    }
    setIsLoading(false)
    return response
  }

  const selectBuilding = (building) => {
    dispatch({
      type: "SELECT_PROJECT",
      data: building
    })
  }

  const updateBuilding = async (building) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateBuilding`, {
      method: "POST",
      body: JSON.stringify(building)
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { code: response.status, message }
  }

  const getParams = async (type) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getParams?group=${type}`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)

    return response
  }

  const updateParams = async (params) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateParam`, {
      method: "POST",
      body: JSON.stringify(params)
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { code: response.status, message }
  }

  const getUnitValues = async (paramId) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getUnitValues?group=${paramId}`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)

    return response
  }

  const updateUnitValues = async (unitValue) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateUnitValue`, {
      method: "POST",
      body: JSON.stringify(unitValue)
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { status: response.status, message }
  }

  const getBuildingItems = async (type, buildingId) => {
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getBuildingItems?type=${type}&buildingId=${buildingId}`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })

    return response
  }

  const updateBuildingItem = async (item) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateBuildingItem`, {
      method: "POST",
      body: JSON.stringify(item)
    })
    const { message, newId } = await response.json()
    setIsLoading(false)
    return { status: response.status, message, newId }
  }

  const getMeasurementUnits = async (type) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getMeasurementUnits`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)

    return response
  }

  const updateMeasurementUnits = async (item) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateMeasurementUnits`, {
      method: "POST",
      body: JSON.stringify(item)
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { code: response.status, message }
  }

  const getIndexers = async ({ month, type } = {}) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const params = new URLSearchParams()
    if (month) params.set("month", month)
    if (type) params.set("type", type)
    const query = params.toString()
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getCost${query ? `?${query}` : ""}`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)

    return response
  }

  const updateIndexer = async (item) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateCost`, {
      method: "POST",
      body: JSON.stringify(item)
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { code: response.status, message }
  }

  const getBuildingTotals = async (buildingId) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getBuildingTotals?buildingId=${buildingId}`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)
    return response
  }

  const getIndexes = async () => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getIndexes`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)

    return response
  }

  const updateIndex = async (item) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/updateIndex`, {
      method: "POST",
      body: JSON.stringify({ name: item })
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { code: response.status, message }
  }

  const updateCubFilter = (item) => {
    dispatch({
      type: "SELECT_CUB_FILTER",
      data: item
    })
  }

  const updateAllCubs = (item) => {
    dispatch({
      type: "UPDATE_ALL_CUBS",
      data: item
    })
  }

  const getCredors = async (name = '', page = 1, type = 'loose') => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/getCredors?name=${name}&page=${page}&type=${type}`, {
      method: "GET"
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)

    return response
  }

  const deleteCostItem = async (id, collection) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/deleteCostItem?itemId=${id}&collectionName=${collection}`, {
      method: "DELETE"
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { status: response.status, message }
  }

  const copyBuildingItems = async (item) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.COSTS_SERVER_URL}/costs/copyBuildingItems`, {
      method: "POST",
      body: JSON.stringify(item)
    })
    const { message } = await response.json()
    setIsLoading(false)
    return { status: response.status, message }
  }

  return {
    getBuildings,
    updateBuilding,
    getParams,
    updateParams,
    getBuildingItems,
    updateBuildingItem,
    getMeasurementUnits,
    updateMeasurementUnits,
    selectBuilding,
    getIndexers,
    updateIndexer,
    getBuildingTotals,
    getIndexes,
    updateIndex,
    updateCubFilter,
    updateAllCubs,
    getCredors,
    getUnitValues,
    updateUnitValues,
    deleteCostItem,
    copyBuildingItems
  };
};
